import React, { useState, useEffect } from "react";
import moment from "moment";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import BackdropLoader from "../../common/components/BackdropLoader";
import { requestStatusColor } from "../../common/components/Utils";

import { useRequiredAuth } from "../../common/guard/requiredAuth";
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";
import RateReviewIcon from "@mui/icons-material/RateReview";
import ViewCaseDialog from "./ViewCaseDialog";
import AssessmentIcon from "@mui/icons-material/Assessment";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";

const CaseCard = (props) => {
  const { user, request, setLoading1, loading1, getCase } = props;
  const { hasPermissions } = useRequiredAuth();
  // console.log(user);
  const [showCaseDetail, setShowCaseDetail] = useState(false);
  // const overdueDays = (departureDate) => {
  //   var departureDate = moment(departureDate);
  //   var currentDate = moment();

  //   // Calculate the difference in days
  //   var overdueDays = currentDate.diff(departureDate, "days");

  //   // Make sure overdueDays is a positive number (if the current date is after the departure date)
  //   overdueDays = Math.max(0, overdueDays);
  //   return overdueDays;
  // };
  const renderButton = () => {
    const isAllowed =
      (request?.approverPlanningEntityId === request?.planningEntityId &&
        !request?.isSentToAppointingAuthority) ||
      (request?.appointingAuthorityPlanningEntityId ===
        request?.approverPlanningEntityId &&
        request?.isSentToAppointingAuthority);
    if (
      hasPermissions([
        "IS_HEAD_OF_INSTITUTION",
        "IS_HEAD_OF_INSTITUTION_ACTING",
      ]) &&
      [1, 2].includes(request.decisionLevel) &&
      [1, 2, 3, 4, 7].includes(+request?.currentLetterTypeId) &&
      +request?.currentLetterStatusId === 1 &&
      isAllowed
    ) {
      return (
        <button type="button" className="btn btn-success m-2">
          <RateReviewIcon /> Click here to sign letter
        </button>
      );
    }

    if (
      +request.decisionLevel === 2 &&
      +request?.doesProvisionalSuspensionInitiated === 1 &&
      hasPermissions([
        "IS_HEAD_OF_INSTITUTION",
        "IS_HEAD_OF_INSTITUTION_ACTING",
      ]) &&
      isAllowed
    ) {
      return (
        <button type="button" className="btn btn-success m-2">
          <RateReviewIcon /> Click here to sign prov. Suspension letter
        </button>
      );
    }

    if (
      ((request.decisionLevel === 1 &&
        [6].includes(+request?.currentLetterTypeId) &&
        hasPermissions(["IS_HEAD_OF_UNIT"])) ||
        (+request.decisionLevel === 2 &&
          [6].includes(+request?.currentLetterTypeId) &&
          hasPermissions([
            "IS_HEAD_OF_INSTITUTION",
            "IS_HEAD_OF_INSTITUTION_ACTING",
          ]))) &&
      +request?.currentLetterStatusId === 1 &&
      isAllowed
    ) {
      return (
        <button type="button" className="btn btn-success m-2">
          <RateReviewIcon /> Click here to sign feedback letter
        </button>
      );
    }

    if (
      hasPermissions(["IS_HR"]) &&
      [2].includes(request.decisionLevel) &&
      [1, 6].includes(+request?.currentLetterTypeId) &&
      +request?.currentLetterStatusId === 1 &&
      !request?.isReviewed &&
      isAllowed
    ) {
      return (
        <button type="button" className="btn btn-primary m-2">
          <RateReviewIcon /> Modify letter
        </button>
      );
    }

    if (
      hasPermissions(["IS_SANCTION_INITIATOR"]) &&
      [2].includes(request.decisionLevel) &&
      [1, 6].includes(+request?.currentLetterTypeId) &&
      +request?.currentLetterStatusId === 1 &&
      !request?.isReviewed &&
      isAllowed
    ) {
      return (
        <button type="button" className="btn btn-primary m-2">
          <RateReviewIcon /> Click here to review
        </button>
      );
    }

    if (
      ((hasPermissions(["IS_HEAD_OF_UNIT"]) && request.decisionLevel === 1) ||
        (hasPermissions(["IS_SANCTION_INITIATOR"]) &&
          request.decisionLevel === 2)) &&
      ((+request?.currentLetterTypeId === 5 &&
        +request?.currentLetterStatusId === 2) ||
        (+request?.currentLetterTypeId === 1 &&
          +request?.currentLetterStatusId === 2 &&
          !!request?.isEmployeeDelayedToRespond)) &&
      isAllowed
    ) {
      return (
        <button type="button" className="btn btn-primary m-2">
          <RateReviewIcon /> Click here to provide feedback
        </button>
      );
    }

    if (
      hasPermissions(["IS_HR"]) &&
      ["SUBMIT_TO_COMMITTEE"].includes(request?.decisionTaken) &&
      !request?.reportCommitteeSummary &&
      +request?.currentLetterTypeId === 6 &&
      +request?.currentLetterStatusId === 2
    ) {
      return (
        <button type="button" className="btn btn-primary m-2">
          <AssessmentIcon /> Click here to submit IDC report
        </button>
      );
    }

    if (
      hasPermissions([
        "IS_HEAD_OF_INSTITUTION",
        "IS_HEAD_OF_INSTITUTION_ACTING",
      ]) &&
      ["WAITING_TO_CLOSE_CASE"].includes(request?.decisionTaken)
    ) {
      return (
        <button type="button" className="btn btn-warning m-2 text-white">
          <DoNotDisturbOnIcon /> Click here to close the case
        </button>
      );
    }
    if (
      hasPermissions(["IS_SANCTION_INITIATOR"]) &&
      ["GIVE_SANCTION"].includes(request?.decisionTaken) &&
      +request?.currentLetterTypeId === 6 &&
      +request?.currentLetterStatusId === 2 &&
      isAllowed
    ) {
      return (
        <button type="button" className="btn btn-primary m-2">
          <CheckCircleOutlineIcon />
          Click here to initiate sanction
        </button>
      );
    }

    if (
      ["GIVE_SANCTION"].includes(request?.decisionTaken) &&
      !!request?.appointingAuthorityPlanningEntityId &&
      !request?.isSentToAppointingAuthority
    ) {
      return (
        <button type="button" className="btn btn-primary m-2">
          <SendOutlinedIcon />
          Send Request to{" "}
          <strong className="ml-1 text-uppercase">
            {request?.appointingAuthorityNameAcronym || "Appointing Authority"}
          </strong>
        </button>
      );
    }

    if (
      [1, 2].includes(+request?.decisionLevel) &&
      [2, 3, 4, 6, 7].includes(+request?.currentLetterTypeId) &&
      +request?.currentLetterStatusId === 1 &&
      hasPermissions(["IS_SANCTION_INITIATOR"]) &&
      isAllowed
    ) {
      return (
        <button type="button" className="btn btn-primary m-2">
          <AssessmentIcon />
          Click here to modify letter
        </button>
      );
    }

    return (
      <button
        type="button"
        disabled={loading1}
        className="btn btn-secondary m-2"
      >
        <OpenInNewIcon /> View Case
      </button>
    );
  };
  return (
    <>
      <BackdropLoader isLoading={loading1} />
      <tr
        disabled={loading1}
        className="appeal-hovered"
        onClick={() => {
          if (!loading1) getCase(request.id, setLoading1, setShowCaseDetail);
        }}
      >
        <td className="text-left">
          <strong> {request.id} </strong>
        </td>

        <td className="text-left text-truncate">
          {request.firstName} {request.lastName}
        </td>

        <td className="text-left text-truncate">
          {request.positionName} ({request.levelName}.{request.scaleName}){" "}
        </td>

        {/* <td className="text-left text-truncate">{request.unitName}</td> */}
        <td className="text-left text-truncate">
          {request.decisionLevel === 2 ? "Second Level" : "First Level"}
        </td>
        <td className="text-left text-truncate">
          {request?.caseSanctionName || "N/A"}
        </td>
        <td className="text-right">{moment(request.createdOn).format("ll")}</td>
        <td className="text-right">{moment(request.updatedOn).format("ll")}</td>

        <td className="text-right">
          <span
            className={`badge py-1 px-2 badge-${requestStatusColor(
              [
                {
                  className: "primary",
                  statusIds: [1],
                },
                {
                  className: "success",
                  statusIds: [2],
                },
              ],
              request.caseStatusId,
            )}`}
          >
            {request.caseStatusName}
          </span>
          {request.caseStatusId === 1 &&
            request?.currentLetterStatusId &&
            request?.currentLetterDesc && (
              <>
                {request?.reportCommitteeSummary &&
                request.caseStatusId === 1 &&
                request?.currentLetterStatusId === 2 &&
                +request?.currentLetterTypeId === 6 ? (
                  <>
                    <span
                      style={{ fontSize: "12px" }}
                      className={`py-0 px-1 text-warning`}
                    >
                      IDC report has been submitted
                    </span>
                  </>
                ) : (
                  <>
                    <span
                      className="py-0 px-1 text-secondary"
                      style={{ fontSize: "12px" }}
                    >
                      {" "}
                      {request.currentLetterDesc}
                    </span>{" "}
                    <span className="py-0 px-0" style={{ fontSize: "12px" }}>
                      -
                    </span>
                    <span
                      style={{ fontSize: "12px" }}
                      className={`py-0 px-1 text-${requestStatusColor(
                        [
                          {
                            className: `${
                              request.currentLetterStatusId === 1
                                ? "warning"
                                : "success"
                            }`,
                            statusIds: [+request.currentLetterStatusId],
                          },
                        ],
                        request.currentLetterStatusId,
                      )}`}
                    >
                      {request.currentLetterStatusName}
                    </span>{" "}
                    {!!request?.isEmployeeDelayedToRespond && (
                      <>
                        <span className="badge badge-danger">Overdue.</span>
                      </>
                    )}
                  </>
                )}
              </>
            )}
        </td>

        <td className="text-right">{renderButton()}</td>
      </tr>
      {showCaseDetail && (
        <ViewCaseDialog
          showCaseDetail={showCaseDetail}
          setShowCaseDetail={setShowCaseDetail}
        />
      )}
    </>
  );
};
export default CaseCard;
